import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import classNames from 'classnames';

import ProfileNavTabs from './ProfileNavTabs';
import css from './ProfileNav.module.css';

export const TAB_PRODUCTS = 'products';
export const TAB_REVIEWS = 'reviews';

const TABS = [TAB_PRODUCTS, TAB_REVIEWS];

const ProfileNav = props => {
  const { rootClassName, className, pathParams, ...rest } = props;
  const classes = classNames(rootClassName || css.root, className);

  const currentTab = pathParams.tab || TABS[0];
  return (
    <div className={classes}>
      <nav className={css.nav}>
        {TABS.map(tabId => {
          const selected = currentTab === tabId;
          return (
            <NamedLink
              key={tabId}
              className={classNames(css.link, {
                [css.linkSelected]: selected,
              })}
              name="ProfilePage"
              params={{ id: pathParams.id, tab: tabId }}
            >
              <FormattedMessage id={`ProfilePage.${tabId}TabTitle`} />
            </NamedLink>
          );
        })}
      </nav>
      <ProfileNavTabs currentTab={currentTab} {...rest} />
    </div>
  );
};

ProfileNav.defaultProps = { rootClassName: null, className: null };

const { string, shape } = PropTypes;

ProfileNav.propTypes = {
  rootClassName: string,
  className: string,
  pathParams: shape({
    id: string.isRequired,
    tab: string,
  }).isRequired,
};

export default ProfileNav;
